import request from '@/router/axios';
import website from "@/config/website";

export const loginByUsername = (tenantId, username, password, type, key, code) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId,
    'Captcha-Key': key,
    'Captcha-Code': code,
    "OperateType": "2"
  },
  params: {
    tenantId,
    username,
    password,
    grant_type: (website.captchaMode ? "captcha" : "password"),
    scope: "all",
    type
  }
});

export const loginByPassword = (tenantId, username, password) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId,
    "OperateType": "2"
  },
  params: {
    tenantId,
    username,
    password,
    grant_type: "password",
    scope: "all",
  }
})

export const loginBySocial = (tenantId, source, code, state) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId,
    "OperateType": "2"
  },
  params: {
    tenantId,
    source,
    code,
    state,
    grant_type: "social",
    scope: "all",
  }
})

export const loginByPhone = (phoneNo, code, key, password) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Captcha-Key': key,
    'Captcha-Code': code,
    "OperateType": "2"
  },
  params: {
    phoneNo,
    password,
    grant_type: 'phone',
    scope: "all",

  }
});

export const refreshToken = (refresh_token, tenantId) => request({
  url: '/api/blade-auth/oauth/token',
  method: 'post',
  headers: {
    'Tenant-Id': tenantId
  },
  params: {
    tenantId,
    refresh_token,
    grant_type: "refresh_token",
    scope: "all",
  }
});

export const registerGuest = (form, oauthId) => request({
  url: '/api/blade-user/register-guest',
  method: 'post',
  params: {
    tenantId: form.tenantId,
    name: form.name,
    account: form.account,
    password: form.password,
    oauthId
  }
});

export const getButtons = () => request({
  url: '/api/blade-system/menu/buttons',
  method: 'get'
});

export const getCaptcha = () => request({
  url: '/api/blade-auth/oauth/captcha',
  method: 'get'
});

export const logout = () => request({
  url: '/api/blade-auth/oauth/logout',
  method: 'get'
});

export const getUserInfo = () => request({
  url: '/api/blade-auth/oauth/user-info',
  method: 'get'
});

export const sendLogs = (list) => request({
  url: '/api/blade-auth/oauth/logout',
  method: 'post',
  data: list
});

export const clearCache = () => request({
  url: '/api/blade-auth/oauth/clear-cache',
  method: 'get'
});

export const checkBindWechat = (uuid, source,nickName, avatar, sex) => request({
  url: '/api/blade-user/wechat/checkBindWechat',
  method: 'post',
  data: {
    uuid: uuid,
    source: source,
    nickname: nickName,
    avatar: avatar,
    gender: sex
  }
});

export const binWechat = (uuid, source, nickName, avatar, sex) => request({
  url: '/api/blade-user/wechat/bind',
  method: 'post',
  data: {
    uuid: uuid,
    source: source,
    nickname: nickName,
    avatar: avatar,
    gender: sex
  }
});
export const getOpenId = (wechatCode) => request({
  url: '/api/blade-wechat/wechat/get-open-Id',
  method: 'get',
  params:{
    code: wechatCode,
  }
});
export const wechatLogin = (code, source) => {
  return request({
    url: '/api/blade-wechat/wechat/wechat-login',
    method: 'post',
    params:{
      code: code,
      source: source
    }
  })
};

export const getOpenIdV2 = (code,appId) => request({
  url: '/api/blade-wechat/wechat/getOpenIdV2',
  method: 'get',
  params:{
    code: code,
    appId: appId
  }
});

export const updatePassword = (oldPassword, newPassword, newPassword1) => {
  return request({
    url: '/api/blade-user/update-password',
    method: 'post',
    params: {
      oldPassword,
      newPassword,
      newPassword1,
    }
  })
};
export const oauthRender=(source)=>{
  return request({
    url: '/api/blade-auth/oauth/render/' + source,
    method: 'get'
  });
}

export const getInfo = () => {
  return request({
    url: '/api/blade-user/info',
    method: 'get'
  })
}

export const getUsertenant = () => {
  return request({
    url: '/api/blade-system/usertenant/user-allow-tenants',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js